import(/* webpackMode: "eager" */ "/var/www/github/coco-app-platform/app/[locale]/error.tsx");
